import { object, string } from "yup";

const NIP_WEIGHTS = [6, 5, 7, 2, 3, 4, 5, 6, 7];

const isValidNip = (value) => {
  const nip = String(value).replace(/[\s-]/g, "");
  if (!/^\d{10}$/.test(nip)) return false;

  const sum = NIP_WEIGHTS.reduce((acc, w, i) => acc + w * Number(nip[i]), 0);
  return sum % 11 === Number(nip[9]);
};

export const createBillingDataSchema = ({ validateNip = true } = {}) =>
  object({
    billing: object({
      name: string().required("Name cannot be empty."),
      tax: object({
        code: string().required("Tax identification type cannot be empty."),
        number: string()
          .required("Tax identification number cannot be empty.")
          .test(
            "valid-pl-nip",
            "Invalid tax identification number",
            function (value) {
              if (!validateNip || this.parent?.code !== "PL VAT" || !value)
                return true;
              return isValidNip(value);
            },
          ),
      }),
      street: string().required("Street cannot be empty."),
      city: string().required("City cannot be empty."),
      post_code: string().required("Post code cannot be empty."),
      country: string().required("Country cannot be empty."),
    }),
  });

const billingDataSchema = createBillingDataSchema();

export default billingDataSchema;
